// Import the PostHog library
import posthog from "posthog-js";
import { getBrowserInfo } from "../config/firebase";

// Obtener claves de variables de entorno
const posthogApiKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://app.posthog.com";

// Initialize PostHog only if API key is available
if (posthogApiKey) {
  posthog.init(posthogApiKey, {
    api_host: posthogHost,
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') {
        // Log that PostHog is loaded in development
        console.log('PostHog loaded in development mode');
      }
    },
  });
} else {
  // Proporcionar un stub para evitar errores cuando el API key no está disponible
  console.warn('PostHog API key not available, analytics will not be tracked.');
}

/**
 * Logs an event to PostHog.
 * @param eventName - The name of the event to log.
 * @param properties - (Optional) Additional properties to include with the event.
 * @param distinctId - (Optional) A unique identifier for the user associated with the event.
 */
export function logPosthogEvent(
  eventName: string,
  properties: Record<string, any> = {},
  distinctId?: string,
): void {
  // No realizar tracking si la clave de API no está disponible
  if (!posthogApiKey) {
    console.debug(`Event not logged (PostHog disabled): ${eventName}`, properties);
    return;
  }

  if (distinctId) {
    // Identify the user if a distinctId is provided
    posthog.identify(distinctId);
  }

  // Log the event
  posthog.capture(eventName, { ...getBrowserInfo(), ...properties });

  if (process.env.NODE_ENV === 'development') {
    console.log(`Event logged: ${eventName}`, properties);
  }
}
